import libConstants from '../../../../constants';
import { ccButtonConstants, ccButtonPropsDefaults } from '../../../../Button';
import { getValidProp } from '../../../../../../../utils/cleanValidateStringPropValue';
import handleClick from '../../../../../../../utils/handleClick';
import computeClassName from '../../../../../../../utils/computeClassName';

const constants = Object.freeze({
  COMPONENT_NAME: 'CCFormInputButtonSecondary',
  CLASSNAME_BASE: 'appearance-none font-bold transition-cc-colors duration-100 ease-linear inline-flex flex-row items-center justify-center',
  CLASSNAME_IS_DISABLED: {
    true: 'cursor-auto bg-cc-white ring-1 ring-inset ring-cc-muted text-cc-muted-contrast rounded-lg',
    false: 'cursor-pointer bg-cc-accent-contrast hover:bg-cc-accent-60 ring-1 ring-inset ring-cc-accent hover:ring-0 focus:outline-none focus-visible:outline-none focus:shadow-pf-focus text-cc-accent hover:text-cc-accent-contrast rounded-lg',
  },
  CLASSNAME_SIZE: Object.fromEntries(
    new Map([
      [ccButtonConstants.SIZE_SMALL, 'px-4 py-2 text-cc-body-small'],
      [ccButtonConstants.SIZE_MEDIUM, 'px-6 py-2.5 text-cc-body-medium'],
      [ccButtonConstants.SIZE_LARGE, 'px-8 py-4 text-cc-body-large']
    ])
  ),
  SIZES: [ccButtonConstants.SIZE_SMALL, ccButtonConstants.SIZE_MEDIUM, ccButtonConstants.SIZE_LARGE],
});

function getValidSize(propsSize) {
  return getValidProp(propsSize, 'size', ccButtonConstants.SIZE_DEFAULT, constants.SIZES, constants.COMPONENT_NAME, libConstants.LIB_DEBUG_LOGGER)
}

function handleChange() { return (event) => {} }

export default function CCFormInputButtonSecondary(
  {
    id,
    name,
    value = ccButtonPropsDefaults.title,
    size = ccButtonPropsDefaults.size,
    clickFn = ccButtonPropsDefaults.clickFn,
    clickFnArgs = ccButtonPropsDefaults.clickFnArgs,
    isDisabled = ccButtonPropsDefaults.isDisabled,
    className = ''
  }
) {
  const validSize = getValidSize(size);
  const validIsDisabled = isDisabled === true || isDisabled === false ? isDisabled : false;
  const computedClassName =
    computeClassName(
      className,
      `${constants.CLASSNAME_BASE} ${constants.CLASSNAME_IS_DISABLED[validIsDisabled]} ${constants.CLASSNAME_SIZE[validSize]}`
    );

  let dynamicProps = {};
  dynamicProps['onChange'] = handleChange();
  if (!!id) dynamicProps['id'] = id;
  if (!!name) dynamicProps['name'] = name;
  if (!!value) dynamicProps['value'] = value;
  if (validIsDisabled) {
    dynamicProps['disabled'] = true;
  }
  else {
    dynamicProps['onClick'] = handleClick(clickFn, clickFnArgs);
  }

  return (
    <input type='button'
           className={computedClassName}
           {...dynamicProps}/>
  )
}
